module.exports = __webpack_public_path__ + "static/media/YF34_3.d552698c.jpg";